module.exports = __webpack_public_path__ + "static/media/python-intermediate.1850053b.png";